import {
  FETCH_PRODUCT_CATEGORY,
  RESET_PRODUCT_CATEGORY,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const productCategoryViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_CATEGORY:
      return { data: action.payload };
    case RESET_PRODUCT_CATEGORY:
      return initialState;
    default:
      return state;
  }
};

export default productCategoryViewReducer;
